import type { ReactNode } from 'react';
import { atom } from 'jotai';
import type { StyleObject } from 'styletron-react';
export type DrawerStyleOverridesT = {
  body?: StyleObject;
  content?: StyleObject;
  header?: StyleObject;
};
export type DrawerPropsT<TProps = unknown> = {
  onClose: (data?: unknown) => void;
  openDrawer: (drawer: DrawerT<TProps>) => void;
  props?: TProps;
  styleOverrides?: DrawerStyleOverridesT;
};
export type DrawerT<TProps = unknown> = {
  id: string;
  title: string;
  titleStartEnhancer?: ReactNode;
  titleEndEnhancer?: ReactNode;
  description?: string;
  content: (drawerProps: DrawerPropsT<TProps>) => ReactNode;
  props?: TProps;
  styleOverrides?: DrawerStyleOverridesT;
  onClose?: (data?: unknown) => void;
};
export const drawersAtom = atom<DrawerT[]>([]);
export const openDrawerAtom = atom(null, (get, set, drawer: DrawerT) => {
  const current = get(drawersAtom);
  set(drawersAtom, [...current, drawer]);
});
export const closeDrawerAtom = atom(null, (get, set, data?: unknown) => {
  const drawers = get(drawersAtom);
  if (drawers.length === 0) return;
  const closingDrawer = drawers[drawers.length - 1];
  if (!closingDrawer) return;
  set(drawersAtom, drawers.slice(0, -1));
  closingDrawer.onClose?.(data);
});
export const closeAllDrawersAtom = atom(null, (get, set) => {
  set(drawersAtom, []);
});